import { render, staticRenderFns } from "./IndividualForm.vue?vue&type=template&id=343910c4&"
import script from "./IndividualForm.vue?vue&type=script&lang=js&"
export * from "./IndividualForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports